export const LocalStorage = {
  Language: 'language',
  Remember: 'remember',
};

export const CookieStorage = {
  token: 'Identity.Token',
};
